import { Routes } from '@/constants';
import { REDIRECT_URL_PARAM } from '../../constants/pages';

export const getRedirectUrl = (returnUrl?: string): string => {
  if (!returnUrl && typeof window !== 'undefined') {
    const params = new URLSearchParams(location.search);
    const returnUrlParam = params.get(REDIRECT_URL_PARAM);
    returnUrl = Array.isArray(returnUrlParam) ? returnUrlParam[0] : returnUrlParam;
  }
  return (returnUrl && decodeURIComponent(returnUrl)) || Routes.INDEX;
};
